module.exports = __webpack_public_path__ + "static/media/download.36e872eb.svg";